module.exports = __webpack_public_path__ + "img/UDVN-2.651de2bc.png";